/*
 * @Description: 格式化日期
 * @Author: Li Guangyin
 * @Date: 2022-02-24 15:03:19
 * @LastEditTime: 2022-02-25 18:44:03
 */
// 获取中间日期
export function getAllDate(start, end){
  let dateArr =  []
  let startArr = start.split('-')
  let endArr = end.split('-')
  let db = new Date()
  db.setUTCFullYear(startArr[0],startArr[1]-1,startArr[2])
  let de = new Date()
  de.setUTCFullYear(endArr[0],endArr[1]-1,endArr[2])
  let unixDb = db.getTime()
  let unixDe = de.getTime()
  let stamp 
  const oneDay = 24 * 60 * 60 * 1000
  for(stamp=unixDb;stamp<=unixDe;){
    dateArr.push(format(new Date(parseInt(stamp))))
    stamp = stamp + oneDay
  }
  return dateArr
}
// 中国标准时间format yyyy-mm-dd
export function format(time){
  let ymd = '' // yyyy-mm-yy
  let mmd = '' // mm-dd
  let mon = (time.getMonth()+1)>= 10?(time.getMonth()+1):('0'+(time.getMonth()+1))
  let newMon = time.getMonth()+1
  let days = time.getDate()
  let week = String(time.getDay()).replace('0','日').replace('1','一').replace('2','二').replace('3','三').replace('4','四').replace('5','五').replace('6','六')
  ymd +=time.getFullYear()+ '-'
  ymd += mon + '-'
  ymd +=days
  mmd += newMon + '月'
  mmd += days + '日'
  return {
    ymd,
    mmd,
    days,
    week,
    newMon
  }
}